import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Youtube from 'react-youtube';
import PublicIcon from '@material-ui/icons/Public';
import GroupIcon from '@material-ui/icons/People';
import FaceIcon from '@material-ui/icons/Person';
import Avatar from '@material-ui/core/Avatar';
import PhotoIcon from '@material-ui/icons/AddAPhotoOutlined';
import VideoIcon from '@material-ui/icons/VideocamOutlined';
import ContentIcon from '@material-ui/icons/ClassOutlined';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import InputAdornment from '@material-ui/core/InputAdornment';
import RemoveIcon from '@material-ui/icons/Clear';
import Popover from '@material-ui/core/Popover';
import IconButton from '@material-ui/core/IconButton';
import Input from '@material-ui/core/Input';
import EmoteIcon from '@material-ui/icons/InsertEmoticon';
import FineUploaderTraditional from 'fine-uploader-wrappers';
import SocialWallPost from './socialwall-post.container';
import EmojiPicker from './emoji-picker';
import ENV from '../../../run-config';
import FileUploadButton from '../../components/uploader';
import extractVideoId from '../../util/extractVideoIdFromYoutube';
import ContentPicker from './content-picker.container';
import { ThemeColors } from '../../theme';
import SearchBar from '../search/search-bar';
import { LoadingIndicator, Button, SocialSelect } from '../../components';
import LinkedContentView from './linked-content-view';

class SocialWall extends Component {

  constructor(props) {
    super(props);
    this.state = {
      post: '',
      inputFocused: false,
      postImages: [],
      selectedUserGroup: null,
      contentSelectionOpen: null,
    };
  }

  componentWillMount() {
    this.props.loadSocialPosts({
      skip: 0,
      take: 5,
    });
  }

  onSearch = (searchTerm) => {
    this.props.history.push(`/search?searchTerm=${searchTerm}`);
  }

  handleLoadMorePosts = () => {
    let filter = {};

    if (this.state.selectedUserGroup && this.state.selectedUserGroup.id) {
      filter = {
        filterType: 'UserGroup',
        filterId: this.state.selectedUserGroup.id,
      };
    }

    this.props.loadSocialPosts({
      isReloadResquest: true,
      skip: this.props.posts.length,
      take: 5,
      ...filter,
    });
  }


  handleCreatePost = () => {
    const userGroupIds = this.props.userGroups.map(g => g.id);

    const dto = {
      creatorType: this.state.creatorType || 'User',
      creatorId: this.state.creatorId || this.props.user.id,
      title: '',
      content: this.state.post,
      videoLink: this.state.videoLink,
      linkedContent: this.state.linkedContent,
      pinnedByAdmin: false,
      groupType: 'UserGroup',
      groupIds: this.state.selectedUserGroupForPost ? [this.state.selectedUserGroupForPost.id] : userGroupIds,
      imageUrls: this.state.postImages,
    };

    this.props.createPost(dto);

    this.setState({
      videoLink: '',
      linkedContent: null,
      userGroupSelected: null,
      postImages: [],
      post: '',
    });
  }

  handleOpenEmoteDialog = (event) => {
    this.setState({
      emoteDialogOpen: event.currentTarget,
    });
  }

  handleCloseEmoteDialog = () => {
    this.setState({
      emoteDialogOpen: false,
    });
  }

  handleInsertEmoji = (event, selection) => {
    this.setState({
      post: `${this.state.post}${selection.emoji}`,
      emoteDialogOpen: false,
    });
  }

  handleInputFocused = () => {
    this.setState({
      inputFocused: true,
    });
  }

  handleInputFocusLost = () => {
    this.setState({
      inputFocused: false,
    });
  }

  handleSelectContent = (id, type, name, parentId) => {
    this.setState({
      linkedContent: {
        linkedContentId: id,
        linkedContentType: type,
        linkedContentName: name,
        parentId,
      },
    });
  }

  handleRemoveImage = (img) => {
    this.setState({
      postImages: this.state.postImages.filter(i => i !== img),
    });

    this.props.removeImage(img);
  }

  handleYoutubePopoverClose = () => {
    this.setState({
      youtubePopoverOpen: null,
    });
  }

  handleYoutubePopoverOpen = (event) => {
    this.setState({
      youtubePopoverOpen: event.currentTarget,
    });
  }

  handleOpenContentSelection = (event) => {
    this.setState({
      contentSelectionOpen: event.currentTarget,
    });
  }

  handleCloseContentSelection = () => {
    this.setState({
      contentSelectionOpen: null,
    });
  }

  handleSelectUserGroup = (userGroup) => {
    this.setState({
      selectedUserGroup: userGroup,
    });

    this.props.loadSocialPosts({
      skip: 0,
      take: 5,
      filterType: userGroup.id ? 'UserGroup' : '',
      filterId: userGroup.id,
    });
  }

  handlePostAs = (item) => {
    this.setState({
      creatorType: item.entity,
      creatorId: item.entityId,
      creatorName: item.text,
    });
  }


  handleUserGroupForPostSelected = (userGroup) => {
    let groupIds = [];
    if (!userGroup || !userGroup.id) {
      groupIds = this.props.userGroups.map(g => g.id);
    } else {
      groupIds = [userGroup.id];
    }

    this.setState({
      groupIds,
      selectedUserGroupForPost: userGroup,
    });
  }

  getUserGroupName = (id) => {
    if (!this.props.userGroups) return '';
    const userGroup = this.props.userGroups.find(f => f.id === id);
    return userGroup ? userGroup.name : '';
  }

  renderLinkedContent() {
    return (
      <LinkedContentView
        history={this.props.history}
        linkedContent={this.state.linkedContent}
      />
    );
  }

  renderYoutubePreview() {
    if (!this.state.videoLink) return null;

    const videoId = extractVideoId(this.state.videoLink);

    const opts = {

      width: '100%',
      playerVars: {
        showinfo: 0,
        rel: 0,
      },
    };

    return (
      <div>
        <div
          style={{
            position: 'absolute',
            display: 'flex',
            padding: 5,
            margin: 5,
            alignItems: 'center',
            justifyContent: 'center',
            backgroundColor: 'white',
            borderRadius: 300,
            cursor: 'pointer',
          }}
        >
          <RemoveIcon
            style={{ color: 'black' }}
            onClick={() => this.setState({ videoLink: '' })}
          />
        </div>
        <Youtube
          videoId={videoId}
          opts={opts}
        />
      </div>
    );
  }

  renderYoutubeLinkInput() {
    return (
      <Popover
        open={this.state.youtubePopoverOpen}
        anchorEl={this.state.youtubePopoverOpen}
        onClose={this.handleYoutubePopoverClose}
      >
        <div style={{ padding: 10 }}>
          <TextField
            placeholder="Youtube Link"
            style={{ width: '100%' }}
            value={this.state.youtubeLink}
            onChange={e => this.setState({ youtubeLink: e.target.value })}
          />
          <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: 10 }}>
            <Button
              label="Abbrechen"
              onClick={this.handleYoutubePopoverClose}
            />
            <Button
              label="Einfügen"
              color="primary"
              disabled={!this.state.youtubeLink}
              onClick={() => {
                this.handleYoutubePopoverClose();
                this.setState({
                  videoLink: this.state.youtubeLink,
                });
              }}
              variant="contained"
              style={{ marginLeft: 10 }}
            />
          </div>
        </div>
      </Popover>
    );
  }

  renderPreviewImages = () => {
    if (!this.state.postImages || this.state.postImages.length < 1) return null;

    const images = this.state.postImages.map(img => (
      <div>
        <RemoveIcon
          onClick={() => this.handleRemoveImage(img)}
          style={{ cursor: 'pointer', position: 'absolute' }}
        />

        <img src={img} width="200px" style={{ marginRight: 10 }} />
      </div>
    ));

    return (
      <div style={{ display: 'flex' }}>{images}</div>
    );
  }

  renderFileUploader = () => {
    const { classes } = this.props;
    const uploader = new FineUploaderTraditional({
      options: {
        request: {
          endpoint: `${ENV.apiHost}/adminApi/course/file`,
        },
        validation: {
          itemLimit: 2,
        },
        callbacks: {
          onComplete: (id, name, response) => {
            const postImages = this.state.postImages;
            postImages.push(response.displayUrl);
            this.setState({
              postImages,
            });
          },
          onError: (id, name, error) => {
            // this.props.showError('Es können maximal 4 Bilder einfügt werden.');
          },
        },
      },
    });

    const icon = <PhotoIcon className={classes.iconStyle} />;

    return (
      <FileUploadButton uploader={uploader} title="Bilder" icon={icon} />
    );
  }

  renderTextField = () => (

    <Input
      onChange={e => this.setState({ post: e.target.value })}
      value={this.state.post}
      fullWidth
      style={{ marginBottom: 20 }}
      multiline
      // onFocus={this.handleInputFocused}
      rows={this.state.post ? 5 : 1}
      placeholder="Beitrag verfassen ..."
      endAdornment={
        <InputAdornment position="end">
          <IconButton
            onClick={this.handleOpenEmoteDialog}
          >
            <EmoteIcon />
          </IconButton>
        </InputAdornment>
      }
    />
  );


  renderPosts() {
    if (!this.props.posts) return null;

    return this.props.posts.map(p => <SocialWallPost post={p} history={this.props.history} />);
  }

  renderCreatePostButton() {
    const buttonStyle = {
      width: '100%',
      textTransform: 'none',
      fontWeight: 'bold',
      color: ThemeColors.primary1Color,
      borderRadius: 2,
    };

    if (!this.state.post) return null;
    return (
      <Button
        label="Posten"
        onClick={this.handleCreatePost}
        color="secondary"
        variant="contained"
        style={buttonStyle}
      />
    );
  }


  renderUserGroupSelector = (selectItem, key, title) => {
    if (!this.props.userGroups || this.props.userGroups.length <= 1) return null;

    const items = this.props.userGroups.map(g => ({
      text: g.name,
      id: g.id,
      leftIcon: <GroupIcon />,
    })).asMutable();

    const globalOption = {
      text: 'Alle (Alle meine Benutzergruppen)',
      id: null,
      leftIcon: <PublicIcon />,
    };

    items.unshift(globalOption);

    const value = !this.state[key]
      ? 'Alle Benutzergruppen'
      : this.state[key].text;

    return (
      <SocialSelect
        icon={<PublicIcon style={{ marginRight: 10 }} />}
        selectItem={selectItem}
        value={value}
        title={title}
        items={items}
      />
    );
  }

  renderUserAvatar(imageLink) {
    const avatarStyle = {
      marginRight: 5,
      fontSize: 15,
      height: 20,
      width: 20,
    };

    return imageLink
      ? (<Avatar style={avatarStyle} src={imageLink} size={15} />)
      : (<Avatar style={avatarStyle}><FaceIcon /></Avatar>);
  }

  renderPostAsSelection() {
    if (!this.props.roles || !this.props.user) return null;
    const roles = this.props.roles.filter(f => f.roleEntityName);

    const roleItems = roles.map(r => ({
      text: r.roleEntityName,
      entity: r.entity,
      entityId: r.entityId,
      id: r.entityId,
      value: r.id,
      leftIcon: <FaceIcon />,
    })).asMutable();

    roleItems.unshift({
      text: `${this.props.user.firstName} ${this.props.user.lastName}`,
      value: 0,
      id: this.props.user.id,
      entity: 'User',
      entityId: this.props.user.id,
      leftIcon: this.renderUserAvatar(this.props.user.avatarUrl),
    });

    return (
      <div style={{ marginRight: 5 }}>
        <SocialSelect
          icon={<FaceIcon style={{ marginRight: 10 }} />}
          selectItem={this.handlePostAs}
          value={this.state.creatorName || `${this.props.user.firstName} ${this.props.user.lastName}`}
          title="Unter diesem Namen veröffentlichen"
          items={roleItems}
        />
      </div>
    );
  }


  renderCreatePostRestrictionSelection = () => {
    if (!this.state.post) return null;

    return (
      <div style={{ display: 'flex', marginTop: 10, marginBottom: 10 }}>
        {this.renderPostAsSelection()}
        {this.renderUserGroupSelector(this.handleUserGroupForPostSelected, 'selectedUserGroupForPost', 'Sichtbar für:')}
      </div>
    );
  }

  renderCreatePostSection() {
    const { classes } = this.props;

    return (

      <div className={classes.createPostContainer} onFocus={this.handleInputFocused}>
        {this.renderTextField()}
        {this.renderPreviewImages()}
        {this.renderLinkedContent()}
        {this.renderYoutubePreview()}
        <div className={classes.outerActionContainer}>

          <div className={classes.actionContainer}>
            {this.renderFileUploader()}
          </div>
          <div className={classes.actionContainer} onClick={this.handleYoutubePopoverOpen}>
            <VideoIcon className={classes.iconStyle} />
            <Typography>Videos</Typography>
          </div>
          <div
            className={classes.actionContainer}
            onClick={this.handleOpenContentSelection}

          >
            <ContentIcon className={classes.iconStyle} />
            <Typography>Inhalte</Typography>
          </div>
        </div>
        {this.renderCreatePostRestrictionSelection()}
        {this.renderCreatePostButton()}
      </div>
    );
  }

  renderLoadMore() {
    if (!this.props.posts || this.props.posts.length >= this.props.totalCount) return null;
    return (
      <div style={{ width: '100%', display: 'flex', justifyContent: 'center', marginTop: 10 }}>
        <Button
          onClick={this.handleLoadMorePosts}
          variant="text"
          label="Mehr laden"
        />

      </div>
    );
  }

  renderLoadingIndicator() {
    if (this.props.postsLoading) {
      return <LoadingIndicator />;
    }

    return null;
  }

  render() {
    const searchBar = !this.props.disableSearch
      ? <SearchBar location={this.props.location} onSearch={this.onSearch} />
      : null;


    return (
      // <div className="col-lg-10 col-md-12 col-sm-12">
      <div>
        {searchBar}
        <Grid container>
          <Grid style={{ margin: 10, padding: 10 }} xs={12} md={12} lg={8}>
            {this.renderCreatePostSection()}
            <div style={{ display: 'flex', alignItems: 'center', marginTop: 10 }}>
              <Typography style={{ marginRight: 5 }}>Beiträge filtern </Typography>
              {this.renderUserGroupSelector(this.handleSelectUserGroup, 'selectedUserGroup', 'Filtern')}
            </div>

            {this.renderPosts()}
            {this.renderLoadingIndicator()}
            {this.renderLoadMore()}
            {this.renderYoutubeLinkInput()}
          </Grid>
          <Grid xs={12} lg={4} />

        </Grid>

        <EmojiPicker
          onClose={this.handleCloseEmoteDialog}
          open={this.state.emoteDialogOpen}
          onEmojiSelected={this.handleInsertEmoji}
        />

        <ContentPicker
          saveSelection={this.handleSelectContent}
          onClose={this.handleCloseContentSelection}
          open={this.state.contentSelectionOpen}
        />
      </div>
    );
  }
}

SocialWall.propTypes = {
  user: PropTypes.object,
  postsLoading: PropTypes.bool,

};

SocialWall.defaultProps = {
  user: null,
  postsLoading: false,
};

const styles = theme => ({
  createPostContainer: {
    borderColor: 'lightgrey',
    borderWidth: 1,
    borderStyle: 'solid',
    padding: 10,
  },
  iconStyle: {
    fontSize: 20,
    color: 'grey',
    marginRight: 5,
  },
  actionContainer: {
    display: 'flex',
    marginRight: 20,
    alignItems: 'center',
    cursor: 'pointer',
  },
  outerActionContainer: {
    display: 'flex',
    justifyContent: 'flex-start',
  },
});

export default withStyles(styles)(SocialWall);



// WEBPACK FOOTER //
// ./src/app/main/socialwall/socialwall.js